import styled, { keyframes } from 'styled-components';
import { fadeIn } from 'react-animations';
import * as CONSTANTS from '../../../constants/styles';

const fadeInAnimation = keyframes`${fadeIn}`;

export const UninstallContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 200px);

  @media (max-width: ${CONSTANTS.TABLET_MAX_WIDTH}px) {
    display: flex;
    flex-direction: column;
    margin-top: 100px;
    padding: 0 24px;
  }

  @media (max-width: ${CONSTANTS.MOBILE_MAX_WIDTH}px) {
    display: flex;
    flex-direction: column;
    margin-top: 80px;
    height: auto;
    padding: 0 20px;
  }
`;

export const SubmitForm = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 600px;
  margin-left: 50px;

  .ant-input {
    width: 505px;
    height: 120px;
  }

  @media (max-width: ${CONSTANTS.MOBILE_MAX_WIDTH}px) {
    .ant-input {
      width: 100%;
      height: 80px;
    }
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 360px;
  }
`;

export const Header = styled.div`
  text-align: left;
  font-weight: 520;
  font-size: 24px;
  color: ${CONSTANTS.COLORS.BLACK_G1};

  @media (max-width: ${CONSTANTS.MOBILE_MAX_WIDTH}px) {
    text-align: center;
  }
`;

export const Text = styled.p`
  font-size: 15px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${CONSTANTS.COLORS.BLACK_G1};
  margin: 0;

  @media (max-width: ${CONSTANTS.MOBILE_MAX_WIDTH}px) {
    text-align: left;
  }
`;

export const ContentImg = styled.img`
  display: flex;
  justify-content: center;
  margin: 0 auto;
  animation: 400ms ${fadeInAnimation};
  @media (max-width: ${CONSTANTS.MOBILE_MAX_WIDTH}px) {
    width: 400px;
    max-width: 100%;
  }
`;

export const RadioStyle = {
  display: 'flex',
  margin: '8px 5px 8px 0',
};

export const LogoForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 50px;
  text-align: center;

  @media (max-width: ${CONSTANTS.MOBILE_MAX_WIDTH}px) {
    margin-right: 0;
    margin-bottom: 20px;
    padding: 0 16px;
  }
`;
